import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const NavbarHome = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="pt-0.1">
    <nav className="bg-white shadow-lg fixed w-full z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/#nav" className="flex items-center">
            <span className="text-2xl font-bold text-yellow-600">SwarnBhandar</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#about" className="text-gray-700 hover:text-yellow-600 transition">
              About Us
            </Link>
            <Link to="/#team" className="text-gray-700 hover:text-yellow-600 transition">
              Our Team
            </Link>
            <Link to="/#contact" className="text-gray-700 hover:text-yellow-600 transition">
              Contact Us
            </Link>
            {/* <Link to="/pricing" className="text-gray-700 hover:text-yellow-600 transition">
              Pricing
            </Link> */}
            <Link to="/signup">
              <button className="bg-yellow-600 text-white px-6 py-2 rounded-full hover:bg-yellow-700 transition">
                Sign Up
              </button>
            </Link>
            <Link to="/login">
              <button className="border-2 border-yellow-600 text-yellow-600 px-6 py-2 rounded-full hover:bg-yellow-50 transition">
                Log In
              </button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-yellow-600 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link
                to="/#about"
                className="block px-3 py-2 text-gray-700 hover:text-yellow-600 transition"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              
              <Link
                to="/#partners"
                className="block px-3 py-2 text-gray-700 hover:text-yellow-600 transition"
                onClick={() => setIsMenuOpen(false)}
              >
                Our Partners
              </Link>

              <Link
                to="/#contact"
                className="block px-3 py-2 text-gray-700 hover:text-yellow-600 transition"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact Us
              </Link>
              {/* <Link
                to="/pricing"
                className="block px-3 py-2 text-gray-700 hover:text-yellow-600 transition"
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </Link> */}
              <Link to="/signup">
                <button
                  className="w-full bg-yellow-600 text-white px-6 py-2 rounded-full hover:bg-yellow-700 transition mt-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign Up
                </button>
              </Link>
              <Link to="/login">
                <button
                  className="w-full border-2 border-yellow-600 text-yellow-600 px-6 py-2 rounded-full hover:bg-yellow-50 transition mt-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Log In
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
    </div>
  );
};

export default NavbarHome; 